import React from "react"
import styled from "styled-components"
import { FormattedMessage } from "react-intl"
import { FadeIn } from "animate-css-styled-components"
import Box from "../../lib/ui/ui-box"
import Text from "../text"

const BankIcon = styled.img`
  max-width: 212px;
`

export default () => {
  return (
    <FadeIn duration="0.25s" delay="0.9s">
      <Box align="center" justify="center" mt={[2, 2, 4]}>
        <Box
          flexDirection="row"
          align="center"
          justify="flex-start"
          w={["80%", "80%", "80%", "971px"]}
          wrap="wrap"
        >
          <Box flexDirection="column" py={[1]}>
            <Text
              fontFamily="Libre Baskerville"
              fontWeight="400"
              color="#535353"
              fontSize={[2, 2, 3]}
              lineHeight={[3]}
              w={[1, "330px"]}
              mr={[4]}
            >
              <FormattedMessage
                id="logosrow.statement"
                defaults="Our Mortgage Brokers gives access to 20+ lenders"
              />
            </Text>
          </Box>
          <Box flexDirection="column" pr={[3]} py={[1]}>
            <BankIcon
              className="bank-icon"
              src="/images/banks/EquitableBank.png"
              alt="Bank Icon"
            />
          </Box>
        </Box>
      </Box>
    </FadeIn>
  )
}



// WEBPACK FOOTER //
// ./src/components/logos-row/logos-row.component.js